
import React from 'react';
import { CATEGORIES, STATES } from '../constants';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <Logo size={40} showText={true} textColor="light" className="mb-6" />
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              The definitive developer assistant and business directory for Australian built-environment professionals. We bridge the gap between property owners and vetted local expertise.
            </p>
            <div className="flex space-x-4">
               <a href="#" className="w-8 h-8 bg-gray-800 flex items-center justify-center rounded-full hover:bg-brand-600 transition">
                 <span className="sr-only">LinkedIn</span>
                 <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
               </a>
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm font-black uppercase tracking-widest mb-6">Expertise</h3>
            <ul className="space-y-3 text-sm">
              {CATEGORIES.slice(0, 8).map((cat) => (
                <li key={cat}>
                  <Link to={`/directory?category=${encodeURIComponent(cat)}`} className="hover:text-accent-500 transition">
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

           <div>
            <h3 className="text-white text-sm font-black uppercase tracking-widest mb-6">Resources</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/wizard" className="hover:text-white">Project Intelligence Wizard</Link></li>
              <li><Link to="/directory" className="hover:text-white">Directory Search</Link></li>
              <li><Link to="/join" className="hover:text-white">Become a Partner</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms & Legal</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-sm font-black uppercase tracking-widest mb-6">States</h3>
             <ul className="grid grid-cols-2 gap-3 text-sm">
               {STATES.map(state => (
                 <li key={state}>
                   <Link to={`/directory?state=${state}`} className="hover:text-accent-500 transition">
                     {state} Registry
                   </Link>
                 </li>
               ))}
             </ul>
          </div>
        </div>

        {/* Dynamic Local SEO Links Section */}
        <div className="border-t border-gray-800 py-12 mb-12">
           <h4 className="text-white text-[10px] font-black uppercase tracking-[0.3em] mb-8 text-center">Local Planning Hubs</h4>
           <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-6 text-[10px] font-bold uppercase tracking-widest text-gray-500">
              <Link to="/directory?q=Melbourne" className="hover:text-brand-500 transition text-center">Town Planners Melbourne</Link>
              <Link to="/directory?q=Sydney" className="hover:text-brand-500 transition text-center">Architects Sydney</Link>
              <Link to="/directory?q=Brisbane" className="hover:text-brand-500 transition text-center">Surveyors Brisbane</Link>
              <Link to="/directory?q=Perth" className="hover:text-brand-500 transition text-center">Engineers Perth</Link>
              <Link to="/directory?q=Adelaide" className="hover:text-brand-500 transition text-center">Drafting Adelaide</Link>
              <Link to="/directory?q=Geelong" className="hover:text-brand-500 transition text-center">Planners Geelong</Link>
           </div>
        </div>
        
        <div className="border-t border-gray-800 pt-12 text-center text-sm text-gray-500">
          <div className="mb-12 text-gray-500 max-w-5xl mx-auto text-[10px] text-justify space-y-3 bg-gray-800/30 p-8 rounded-2xl border border-gray-800 leading-relaxed uppercase tracking-wider">
            <h5 className="font-black text-gray-400 mb-4">Official Disclaimer</h5>
            <p>PlanStack Australia provides a professional developer assistant and directory service. Information generated by AI tools or listed in our directory is for guidance only and does not constitute formal legal or planning advice. Site-specific outcomes are subject to local council approval and current state legislation. Always engage a registered professional before lodging applications.</p>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
             <p className="text-[10px] font-black uppercase tracking-widest">&copy; {new Date().getFullYear()} PlanStack - Developer Assistant & Business Directory. ABM 12 345 678 901.</p>
             <div className="flex gap-6 text-[10px] font-black uppercase tracking-widest">
                <Link to="/terms" className="hover:text-white transition">Privacy</Link>
                <Link to="/terms" className="hover:text-white transition">Terms</Link>
                <a href="/sitemap.xml" className="hover:text-white transition">Sitemap</a>
             </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
